import * as React from "react";
import { connect } from "react-redux";
import { appAction } from "../../actions/app.action";
import { userAction } from "../../actions/user.action";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import Button from "@material-ui/core/Button/Button";
import SectionHeader from "../../components/UI/SectionHeader";
import TrialRemaining from "../../components/UI/TrialRemaining";
import DateRange from "../../components/Forms/DateRange";
import TextSearchField from "../../components/Forms/TextSearchField";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableBody from "@material-ui/core/TableBody/TableBody";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel/TableSortLabel";
import Typography from "@material-ui/core/Typography/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import withStyles from "@material-ui/core/styles/withStyles";
import { sortAdvisorList, stableSort } from "../../utilities/sorting";
import { formatDate, formatPhone } from "../../utilities/format";
import { withinDateRange } from "../../utilities/filter";
import { isMobile } from "../../utilities/mobile";

const styles = (theme) => ({
  table: {
    "& th": {
      color: theme.palette.primary.main,
      fontSize: 14,
      padding: "4px 10px",
      fontWeight: 500,
      height: "48px",
    },
    "& td": {
      fontSize: 14,
      padding: "4px 10px",
      [theme.breakpoints.down("md")]: {
        padding: "2px",
        fontSize: 12,
      },
    },
  },
  contact: {
    whiteSpace: "nowrap",
    "& svg": {
      fontSize: 16,
      marginRight: "2%",
      verticalAlign: "middle",
      color: "rgba(0, 0, 0, 0.54)",
    },
  },
  actionBtn: {
    [theme.breakpoints.down("md")]: {
      whiteSpace: "nowrap",
      minWidth: 87,
      maxWidth: 87,
      minHeight: 24,
      lineHeight: 0.8,
    },
  },
  filterField: {
    display: "inline-block",
  },
  filterWrapper: {
    marginBottom: "2%",
  },
  advisorFilter: {
    marginLeft: "3%",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginTop: "3%",
    },
  },
});

// AdvisorList class - where displays the list of advisors with
// the advisor data and approved / activated toggle buttons
class AdvisorList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPhone: isMobile.phone(),
      userToggleValues: this.createUserToggleValues(props),
      selectedToggle: { id: 0, name: "approved" },
      showFeedbackMessage: { id: 0, name: "approved", value: false },
      order: "asc",
      orderBy: "trialRemaining",
      columns: [
        {
          id: "fullName",
          numeric: false,
          label: "Advisor",
          sortable: true,
        },
        {
          id: "email",
          numeric: false,
          label: "Contact",
          sortable: true,
        },
        {
          id: "trialRemaining",
          numeric: false,
          label: "Trial Remaining",
          sortable: true,
        },
        {
          id: "totalOnboarded",
          numeric: false,
          label: "# of Onboarded",
          sortable: true,
        },
        {
          id: "lastOnboardAt",
          numeric: false,
          label: "Last Onboarded",
          sortable: true,
        },
        {
          id: "createdAt",
          numeric: false,
          label: "Start Date",
          sortable: true,
        },
        {
          id: "approvedOn",
          numeric: false,
          label: "Approval Date",
          sortable: true,
        },
        {
          id: "logins",
          numeric: false,
          label: "Logins",
          sortable: true,
        },
        {
          id: "bdAffiliation",
          numeric: false,
          label: "BD",
          sortable: true,
        },
        {
          id: "advisorCrdRef",
          numeric: false,
          label: "Advisor CRD",
          sortable: true,
        },
        {
          id: "approved",
          numeric: false,
          label: "Portfolio Visibility",
        },
        {
          id: "UserRoleId",
          numeric: false,
          label: "Subscription",
        },
        {
          id: "isActive",
          numeric: false,
          label: "Activated",
        },
        {
          id: "action",
          numeric: false,
          label: "",
        },
      ],
      filterCreated: {
        from: null,
        to: null,
      },
      advisorSearchQuery: "",
    };
  }

  componentDidMount() {
    this.props.dispatch(userAction.getAllUsers());
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setAdminNav(true));
    if (this.state.isPhone) {
      this.props.dispatch(appAction.toggleMainNav(false));
    }
    window.scrollTo(0, 0);
  }

  // Function to handle approved / isActive toggle button
  handleChange = (e, id) => {
    const { name, checked } = e.target;

    const newUserToggleValuesMap = { ...this.state.userToggleValues };

    newUserToggleValuesMap[id][name] = checked;

    this.setState(
      (prevState) => ({
        ...prevState,
        userToggleValues: newUserToggleValuesMap,
        selectedToggle: { id: id, name: name },
      }),
      () => this.updateUserData(id, name, checked)
    );
  };

  handleRoleChange = (e, id) => {
    const newUserData = { [e.target.name]: e.target.value };
    this.props.dispatch(userAction.updateUserById(id, newUserData));
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  createSortHandler = (property) => (event) => {
    this.handleRequestSort(event, property);
  };

  // Function to create a new object to set updated data(toggle values)
  // and dispatch an action
  updateUserData = (id, name, checked) => {
    const newUserData = { [name]: checked };
    this.props.dispatch(userAction.updateUserById(id, newUserData));
  };

  // Function to update the state of feedback message to display for few seconds
  toggleFeedbackMessage = (id, name) => {
    this.setState(
      { showFeedbackMessage: { id: id, name: name, value: true } },
      () => this.timerHandle()
    );
  };

  // Function to turn off the state of feedback message after few seconds
  // This function is separated to be cancelled when this component unmounts
  timerHandle = () => {
    this.timerId = setTimeout(() => {
      this.setState((prevState) => ({
        ...prevState,
        showFeedbackMessage: {
          ...prevState.showFeedbackMessage,
          value: false,
        },
      }));
    }, 3000);
  };

  // Function to return a feedback message when the state is on
  returnFeedbackMessage = (userId, toggleName) => {
    const { showFeedbackMessage } = this.state;
    if (
      showFeedbackMessage.id === userId &&
      showFeedbackMessage.name === toggleName &&
      showFeedbackMessage.value
    ) {
      return (
        <span
          style={{
            color: "rgb(61, 171, 115)",
            fontSize: "10px",
            position: "absolute",
            top: "22px",
          }}
        >
          Saved
        </span>
      );
    }
    clearTimeout(this.timerId);
  };

  // Push to /Portal/admin/advisor when clicking the tablecell or "See Clients" button
  directToAdvisorDetail = (id) => {
    this.props.history.push(`/Portal/admin/advisor/${id}`);
  };

  // Function to return sorted users by id
  orderById = (users) => {
    return users.sort((a, b) => a.id - b.id);
  };

  // Toggle feedback message when the userUpdating is false on next prop
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedToggle } = this.state;

    if (this.props.userUpdating && !nextProps.userUpdating) {
      this.toggleFeedbackMessage(selectedToggle.id, selectedToggle.name);
    }

    if (nextProps.users !== this.props.users) {
      this.setState({
        userToggleValues: this.createUserToggleValues(nextProps),
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timerId);
  }

  applyFilters = (users = []) => {
    return this.filterByAdvisor(users).filter((user) =>
      withinDateRange(user.createdAt, this.state.filterCreated)
    );
  };

  /* Filter advisor list by advisor name */
  filterByAdvisor = (users) => {
    const { advisorSearchQuery } = this.state;
    return users.filter((user) =>
      user.fullName.toLowerCase().includes(advisorSearchQuery.toLowerCase())
    );
  };

  createUserToggleValues(props) {
    const userToggleValues = {};
    Object.values(props.users).forEach((user) => {
      userToggleValues[user.id] = {
        id: user.id,
        approved: user.approved,
        isActive: user.isActive,
      };
    });
    return userToggleValues;
  }

  render() {
    const {
      advisorSearchQuery,
      columns,
      order,
      orderBy,
      showFeedbackMessage,
      userToggleValues,
    } = this.state;

    const { classes, users, userRoles } = this.props;

    const userList = this.applyFilters(Object.values(users));
    const sortedUserList = stableSort(
      userList,
      sortAdvisorList(order, orderBy)
    );

    return (
      <React.Fragment>
        <SectionHeader text={"Advisors"} />
        <section>
          <div className={classes.filterWrapper}>
            <label
              onClick={(e) => e.preventDefault()}
              className={classes.filterField}
            >
              <Typography>Search by Advisor Created Date:</Typography>
              <DateRange
                onChange={(dateRange) =>
                  this.setState({ filterCreated: dateRange })
                }
              />
            </label>
            <label
              onClick={(e) => e.preventDefault()}
              className={`${classes.filterField} ${classes.advisorFilter}`}
            >
              <Typography>Search by Advisor:</Typography>
              <TextSearchField
                label="Advisor"
                name="advisor"
                value={advisorSearchQuery}
                onChange={(e) =>
                  this.setState({ advisorSearchQuery: e.target.value })
                }
                resetValue={() => this.setState({ advisorSearchQuery: "" })}
              />
            </label>
          </div>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  return (
                    <TableCell
                      key={column.id}
                      align={column.numeric ? "right" : "left"}
                      sortDirection={orderBy === column.id ? order : false}
                    >
                      {column.sortable ? (
                        <Tooltip title="Sort" placement="top" enterDelay={300}>
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={order}
                            onClick={this.createSortHandler(column.id)}
                          >
                            {column.label}
                          </TableSortLabel>
                        </Tooltip>
                      ) : (
                        column.label
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {userList ? (
                sortedUserList.map((user) => (
                  <TableRow
                    key={user.id}
                    hover={true}
                    onClick={() => this.directToAdvisorDetail(user.id)}
                  >
                    <TableCell>{user.fullName}</TableCell>
                    <TableCell>
                      <div className={classes.contact}>
                        {user.email && (
                          <React.Fragment>
                            <Email />
                            {user.email}
                          </React.Fragment>
                        )}
                      </div>
                      <div className={classes.contact}>
                        {user.phone && (
                          <React.Fragment>
                            <Phone />
                            {formatPhone(user.phone)}
                          </React.Fragment>
                        )}
                      </div>
                    </TableCell>
                    <TableCell>
                      <TrialRemaining user={user} />
                    </TableCell>
                    <TableCell>{user.totalOnboarded}</TableCell>
                    <TableCell>
                      {user.lastOnboardAt && formatDate(user.lastOnboardAt)}
                    </TableCell>
                    <TableCell>
                      {user.createdAt && formatDate(user.createdAt)}
                    </TableCell>
                    <TableCell>
                      {user.approved &&
                        user.approvedOn &&
                        formatDate(user.approvedOn)}
                    </TableCell>
                    <TableCell>{user.logins}</TableCell>
                    <TableCell>{user.bdAffiliation}</TableCell>
                    <TableCell>{user.advisorCrdRef}</TableCell>
                    <TableCell onClick={(e) => e.stopPropagation()}>
                      <Switch
                        checked={userToggleValues[user.id].approved}
                        onChange={(e) => this.handleChange(e, user.id)}
                        name="approved"
                        color="primary"
                      />
                      {showFeedbackMessage.value &&
                        this.returnFeedbackMessage(user.id, "approved")}
                    </TableCell>
                    <TableCell onClick={(e) => e.stopPropagation()}>
                      <Select
                        defaultValue={user.UserRoleId}
                        onChange={(e) => this.handleRoleChange(e, user.id)}
                        disabled={this.props.userUpdating || this.props.user.user.id === user.id}
                        inputProps={{ name: "UserRoleId" }}
                        style={{ minWidth: 100 }}
                      >
                        { userRoles.map(({id, role}, k) => (
                          <MenuItem key={k} value={id}>
                            {role}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell onClick={(e) => e.stopPropagation()}>
                      <Switch
                        checked={userToggleValues[user.id].isActive}
                        onChange={(e) => this.handleChange(e, user.id)}
                        name="isActive"
                        color="primary"
                        disabled={this.props.user.user.id === user.id}
                      />
                      {showFeedbackMessage.value &&
                        this.returnFeedbackMessage(user.id, "isActive")}
                    </TableCell>
                    <TableCell onClick={(e) => e.stopPropagation()}>
                      <Button
                        style={{ fontSize: 12, textTransform: "none" }}
                        variant="contained"
                        size={"small"}
                        onClick={() => this.directToAdvisorDetail(user.id)}
                        className={classes.actionBtn}
                      >
                        See Clients
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={13} style={{ textAlign: "center" }}>
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    users: state.users.map,
    userUpdating: state.user.userUpdating,
    userRoles: state.app.userRoles,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(AdvisorList));



// WEBPACK FOOTER //
// ./src/containers/AdminAdvisorList/index.jsx